// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__AdminSidebar from "./AdminSidebar.js";
import * as Buhta_cabinet__Link from "../../html/Link.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Auth from "../../../../../../packages/core/lib/Auth.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function AdminSidebarMobile$SidebarMain(Props) {
  let onClose = Props.onClose;
  let setIsDropdownShown = Props.setIsDropdownShown;
  const match = Buhta_core__Auth.IdentityContext.useIdentity(undefined);
  const identity = match[0];
  let userpic;
  if (/* tag */ typeof identity === "number" || typeof identity === "string" || identity.TAG !== /* Authorized */ 0) {
    userpic = StaticAsset.src("/static/icons/profile-photo.png");
  } else {
    const identityProfile = identity._0;
    userpic = identityProfile.userpic_url === "" ? StaticAsset.src("/static/icons/profile-photo.png") : identityProfile.userpic_url;
  }
  let fullName;
  if (/* tag */ typeof identity === "number" || typeof identity === "string" || identity.TAG !== /* Authorized */ 0) {
    fullName = "Профиль";
  } else {
    const identityProfile$1 = identity._0;
    fullName = identityProfile$1.first_name + (" " + identityProfile$1.last_name);
  }
  const sidebarItems_0 = {
    label: "Главная",
    route: /* Main */ 0,
    isActiveRoute: undefined
  };
  const sidebarItems_1 = {
    hd: {
      label: "Предприятия",
      route: {
        TAG: /* Orgs */ 1,
        _0: /* List */ 0
      },
      isActiveRoute: (function (param) {
        if (/* tag */ typeof param === "number" || typeof param === "string") {
          return false;
        }
        if (param.TAG !== /* Admin */ 7) {
          return false;
        }
        let tmp = param._0;
        if (/* tag */ typeof tmp === "number" || typeof tmp === "string" || tmp.TAG !== /* Orgs */ 1) {
          return false;
        } else {
          return true;
        }
      })
    },
    tl: {
      hd: {
        label: "Пользователи",
        route: {
          TAG: /* Identities */ 2,
          _0: /* List */ 0
        },
        isActiveRoute: (function (param) {
          if (/* tag */ typeof param === "number" || typeof param === "string") {
            return false;
          }
          if (param.TAG !== /* Admin */ 7) {
            return false;
          }
          let tmp = param._0;
          if (/* tag */ typeof tmp === "number" || typeof tmp === "string" || tmp.TAG !== /* Identities */ 2) {
            return false;
          } else {
            return true;
          }
        })
      },
      tl: {
        hd: {
          label: "Ключи",
          route: {
            TAG: /* Keychain */ 0,
            _0: {
              TAG: /* Keys */ 0,
              _0: /* List */ 0
            }
          },
          isActiveRoute: (function (param) {
            if (/* tag */ typeof param === "number" || typeof param === "string") {
              return false;
            }
            if (param.TAG !== /* Admin */ 7) {
              return false;
            }
            let tmp = param._0;
            if (/* tag */ typeof tmp === "number" || typeof tmp === "string" || tmp.TAG !== /* Keychain */ 0) {
              return false;
            } else {
              return true;
            }
          })
        },
        tl: /* [] */ 0
      }
    }
  };
  const sidebarItems = {
    hd: sidebarItems_0,
    tl: sidebarItems_1
  };
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx("div", {
        children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(sidebarItems, (function (index, item) {
          return JsxRuntime.jsx(Buhta_cabinet__AdminSidebar.SidebarContent.Item.make, {
            item: item,
            onClose: onClose
          });
        }))),
        className: "mt-6 px-4"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("button", {
          children: [
            JsxRuntime.jsx("img", {
              className: "w-5 h-5 rounded-50pct",
              src: userpic
            }),
            JsxRuntime.jsx(Buhta_components__Text.P.make, {
              className: "ml-4 text-gray-medium",
              children: fullName
            })
          ],
          className: "flex py-1.5 mt-6 px-4 items-center",
          onClick: (function (param) {
            Curry._1(setIsDropdownShown, (function (param) {
              return true;
            }));
          })
        }),
        className: "absolute bottom-6 w-full"
      })
    ]
  });
}

const SidebarMain = {
  make: AdminSidebarMobile$SidebarMain
};

function AdminSidebarMobile(Props) {
  let isOpen = Props.isOpen;
  let onClose = Props.onClose;
  Buhta_core__Tenant.useTenant(undefined);
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
  const currentUrlStr = Buhta_cabinet__Route.toString(currentRoute);
  const match = React.useState(function () {
    return false;
  });
  const setIsDropdownShown = match[1];
  let tmp;
  tmp = null;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            tmp,
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                  className: "text-white",
                  children: "Меню"
                }),
                JsxRuntime.jsx("div", {
                  className: "border-l border-asphalt-dark h-5"
                }),
                JsxRuntime.jsx("button", {
                  children: JsxRuntime.jsx("img", {
                    src: StaticAsset.src("/static/icons/close-white-24.svg")
                  }),
                  onClick: (function (param) {
                    Curry._1(onClose, undefined);
                  })
                })
              ],
              className: "flex items-center gap-2 ml-auto"
            })
          ],
          className: "flex justify-between items-center"
        }),
        className: "px-4"
      }),
      JsxRuntime.jsx(AdminSidebarMobile$SidebarMain, {
        onClose: onClose,
        setIsDropdownShown: setIsDropdownShown
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Buhta_cabinet__Link.make, {
              route: /* OrgChoose */ 0,
              className: "p-2 hover:bg-gray-pale block",
              onLinkClicked: (function (param) {
                Curry._1(setIsDropdownShown, (function (param) {
                  return false;
                }));
              }),
              children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                children: "Кабинет"
              })
            }),
            JsxRuntime.jsx(Buhta_cabinet__Link.make, {
              route: {
                TAG: /* Profile */ 5,
                _0: /* General */ 0
              },
              className: "p-2 hover:bg-gray-pale block",
              onLinkClicked: (function (param) {
                Curry._1(setIsDropdownShown, (function (param) {
                  return false;
                }));
              }),
              children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                children: "Настройки профиля"
              }),
              urlParams: {
                hd: [
                  "return_to",
                  currentUrlStr
                ],
                tl: /* [] */ 0
              }
            }),
            JsxRuntime.jsx("hr", {
              className: "my-1"
            }),
            JsxRuntime.jsxs("button", {
              children: [
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: "text-alert",
                  children: "Выйти из аккаунта"
                }),
                JsxRuntime.jsx("img", {
                  className: "w-5 h-5",
                  src: StaticAsset.src("/static/icons/logout-red-20.svg")
                })
              ],
              className: "flex p-2 hover:bg-gray-pale justify-between w-full",
              onClick: (function (param) {
                window.location.href = "/logout";
              })
            })
          ],
          className: "bg-white w-60 p-2 shadow-kkms rounded-sm absolute bottom-16"
        }),
        className: Cn.$plus("absolute inset-0 pl-4", Cn.on("hidden", !match[0])),
        onClick: (function (param) {
          Curry._1(setIsDropdownShown, (function (param) {
            return false;
          }));
        })
      })
    ],
    className: Cn.$plus(Cn.$plus("fixed inset-0 bg-black z-50 pt-2.5", Cn.on("block", isOpen)), Cn.on("hidden", !isOpen))
  });
}

const make = AdminSidebarMobile;

export {
  SidebarMain,
  make,
}
/* Buhta_cabinet__AdminSidebar Not a pure module */
